import { useEffect } from 'react'
import { getPersistor } from 'src/Libs/system-data-handler/state/store'

/**
 * purge storage data when too less space remaining
 */
const useStoragePurge = (): void => {
  const purgeStorage = async (): Promise<void> => {
    const estimate = await navigator?.storage?.estimate?.()
    const quota = estimate?.quota
    const usage = estimate?.usage

    // if less than 2 MB space is remaining clear the store
    if (quota && usage && quota - usage < 2000000) {
      await getPersistor()?.purge()
    }
  }

  useEffect(() => {
    purgeStorage().catch(console.error)
  }, [])
}

export default useStoragePurge
